import React from 'react'
import { Spin, Select } from 'antd'
import debounce from 'lodash/debounce'
import API from '../services/API'

const { Option } = Select
const DEBOUNCE_DELAY = 1000

const Search = ({
    mode = 'default',
    placeholder = '',
    value = '',
    onChange,
    onSearch,
    label = 'name',
    keyName = 'id',
    allOptions = false,
    getCollector
}) => {
    const [loading, setLoading] = React.useState(false)
    const [options, setOptions] = React.useState([])

    const fetchQuery = input => {
        const newUrl = onSearch && onSearch(input)
        setLoading(true)
        API.get(newUrl)
            .then(response => {
                let newData = []
                if (Array.isArray(response.data)) {
                    newData = response.data
                } else if (Array.isArray(response.data.data)) {
                    newData = response.data.data
                }

                if (allOptions) {
                    newData.unshift({
                        name: 'Todas las opciones',
                        [label]: 'Todas las opciones',
                        id: 'all',
                    })
                }

                setOptions(newData)
                if (getCollector) {
                    getCollector(newData);
                }
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }

    React.useEffect(() => {
        fetchQuery('')
    }, [])

    const debouncedChangeHandler = React.useMemo(() => debounce(input => fetchQuery(input), DEBOUNCE_DELAY), [])

    React.useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel()
        }
    }, [debouncedChangeHandler]);

    let selectValue = '';
    if (typeof value === 'string' || typeof value === 'number') {
        selectValue = value;
    } else if (typeof value === 'object' && value !== null && keyName in value) {
        selectValue = value[keyName];
    } else {
        selectValue = undefined;
    }

    return (
        <Select
            showSearch
            autoClearSearchValue={true}
            mode={mode}
            style={{ width: '100%' }}
            value={selectValue}
            placeholder={placeholder}
            optionFilterProp="children"
            notFoundContent={loading ? <Spin style={{ margin: '0 auto' }} size="small" /> : 'No hay resultados'}
           // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
           filterOption={(input, option) => {
            if (option && option.props) {
              const { children } = option.props;
              if (children) {
                const lowerCaseChildren = children.toLowerCase();
                const lowerCaseInput = input.toLowerCase();
                return lowerCaseChildren.indexOf(lowerCaseInput) >= 0;
              }
            }
            return false;
          }}
            onSearch={current => {
                // if (current) {
                    debouncedChangeHandler(current)
                // }
            }}
            onChange={key => {
                const value = options.find(f => f[keyName] === key)
                onChange && onChange(key, value)
            }}
        >
            {options.map(d => {
                return (
                    <Option key={d[keyName]} value={d[keyName]}>
                        {d[label]}
                    </Option>
                )
            })}
        </Select>
    )
}

export default Search
